<template>
  <div
    :id="`${source}_sales_force_statuses_select`"
    class="flex w-full justify-center items-center"
  >
    <ThemeImage
      v-if="!read_only"
      class="min-w-4 min-h-4"
      :icon="imageNames.INVERSE_GREY"
      alt="inverse_icon"
    />
    <a-tooltip
      v-else
      placement="top"
      title="This uni-directional field pulls information from your CRM into SuperAGI and can't be pushed back."
    >
      <ThemeImage
        class="min-w-4 min-h-4"
        :icon="imageNames.TO_LEFT_ARROW"
        alt="to_left_arrow"
      />
    </a-tooltip>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
});

const read_only = computed(() => props.row?.read_only);
</script>
